import { useDisclosure } from '@chakra-ui/react';
import { useFormikContext } from 'formik';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { useParams } from 'react-router-dom';
import '../../App.css';
import Alerta from '../../components/Alerta/Alerta';
import BarraBotoes from '../../components/BarraBotoes/BarraBotoes';
import Card from '../../components/Card/Card';
import FormikPadrao from '../../components/FormikPadrao/FormikPadrao';
import InputAutoComplete from '../../components/Inputs/InputAutoComplete/InputAutoComplete';
import InputFormik from '../../components/Inputs/InputFormik/InputFormik';
import InputSelect from '../../components/Inputs/InputSelect/InputSelect';
import InputTexto from '../../components/Inputs/InputTexto/InputTexto';
import Pagina from '../../components/Pagina/Pagina';
import api from '../../services/api';
import { gridColumn } from '../../utils/gridColumn';
import { addIDtoURL, estados } from '../../utils/utils';
import './Estoques.css';
import { valor_inicial } from './utils';

function EditarEstoques() {
  const navigate = useNavigate();
  const [estoque, setEstoque] = useState(valor_inicial);
  const [loading, setLoading] = useState(true);
  const { isOpen, onOpen, onClose } = useDisclosure({ defaultIsOpen: false });
  const [alertStatus, setAlertStatus] = useState('success');
  const [alertTitle, setAlertTitle] = useState('');

  let { id } = useParams();

  useEffect(() => {
    async function GetEstoque() {
      if (alertStatus !== 'success' && alertTitle.length >= 0) return;
      let payload = {
        database: localStorage.getItem('database'),
        data: id,
      };
      let res = await api.post('/EditDepositos/Get', payload);
      if (res.status === 200) {
        let data = res.data;
        setEstoque(data.Deposito);
        setLoading(false);
      } else {
        alert('Erro ao buscar dados');
      }
    }
    GetEstoque();
  }, [id, alertTitle, alertStatus]);

  let save = async value => {
    setLoading(true);
    let payload = {
      data: value,
      database: localStorage.getItem('database'),
    };
    let res = await api.post('/EditDepositos/Save', payload);
    let data = res.data;
    setLoading(false);
    if (data.Success) {
      setAlertStatus('success');
      setAlertTitle(data.MSG);
      onOpen();
      addIDtoURL(id, data.ItemID);
    } else {
      setAlertStatus('error');
      setAlertTitle(data.MSG);
      onOpen();
    }
  };

  return (
    <>
      <Alerta
        isOpen={isOpen}
        onClose={onClose}
        onOpen={onOpen}
        alertStatus={alertStatus}
        title={alertTitle}
      />
      <Pagina loading={loading}>
        <FormikPadrao
          enableReinitialize={true}
          initialValues={estoque}
          /*validationSchema: yup.object({
          Nome: yup.string().required('O campo é obrigatório.').nullable(),
          Empresa: yup.string().required('O campo é obrigatório.').nullable(),
          EmpresaId: yup.number().typeError('O valor deve ser um número').required('O campo é obrigatório.').nullable(),
          CEP: yup.number().typeError('O valor deve ser um número').required('O campo é obrigatório.').nullable(),
          RuaEndereco: yup.string().required('O campo é obrigatório.').nullable(),
          NumeroEndereco: yup.number().typeError('O valor deve ser um número').required('O campo é obrigatório.').nullable(),
          ComplementoEndereco: yup.string().required('O campo é obrigatório.').nullable(),
          BairroEndereco: yup.string().required('O campo é obrigatório.').nullable(),
          CidadeEndereco: yup.string().required('O campo é obrigatório.').nullable(),
          CodigoCidadeEndereco: yup.number().typeError('O valor deve ser um número').required('O campo é obrigatório.').nullable(),
          UFEndereco: yup.string().required('O campo é obrigatório.').nullable(),
          CodigoUFEndereco: yup.number().typeError('O valor deve ser um número').required('O campo é obrigatório.').nullable(),
          PaisEndereco: yup.string().required('O campo é obrigatório.').nullable(),
          CodigoPaisEndereco: yup.number().typeError('O valor deve ser um número').required('O campo é obrigatório.').nullable(),
          Responsavel: yup.string().required('O campo é obrigatório.').nullable(),
          Telefone: yup.number().typeError('O valor deve ser um número').required('O campo é obrigatório.').nullable(),
          Email: yup.string().email('Digite um email válido').required('O campo é obrigatório.').nullable(),
        }),*/
          onSubmit={async values => {
            setEstoque(values);
            await save(JSON.stringify(values, null, 2));
          }}
        >
          <Interno navigate={navigate} />
        </FormikPadrao>
      </Pagina>
    </>
  );
}

function Interno({ navigate }) {
  const formik = useFormikContext();
  let titulo = `${formik.values.Id !== '' ? 'Editar' : 'Novo'
    } Estoque`;

  /*useEffect(() => {
    async function fetchData(cep) {
      const response = await fetch(`https://viacep.com.br/ws/${cep}/json`);
      const data = await response.json();
      formik.setFieldValue('RuaEndereco', data.logradouro);
      formik.setFieldValue('BairroEndereco', data.bairro);
      formik.setFieldValue('CidadeEndereco', data.localidade);
      formik.setFieldValue('CodigoCidadeEndereco', data.ibge);
      formik.setFieldValue('UFEndereco', data.uf);
      formik.setFieldValue('CodigoUFEndereco', data.ibge);
      formik.setFieldValue('PaisEndereco', 'Brasil');
      formik.setFieldValue('CodigoPaisEndereco', '1058');
    }
    if (
      formik.values.CEP.length === 8 &&
      formik.values.CEP !== formik.initialValues.CEP
    ) {
      if (
        formik.values.RuaEndereco === '' &&
        formik.values.BairroEndereco === '' &&
        formik.values.CidadeEndereco === ''
      ) {
        if (formik.touched.CEP) {
          fetchData(formik.values.CEP);
        }
      }
    }
  }, [formik]);*/

  return (
    <>
      <BarraBotoes
        botoes={[
          {
            variant: 'vermelho',
            onClick: () => navigate('/Estoques/Listar'),
            children: 'Cancelar',
          },
          {
            variant: 'turquesa',
            type: 'submit',
            children: 'Salvar',
          },
        ]}
        caminho={[
          { nome: 'Estoques', path: '/Estoques/Listar' },
          { nome: titulo },
        ]}
      />

      <Card titulo="NOVO ESTOQUE">
        <InputFormik
          titulo="Nome"
          id="Nome"
          name="Nome"
          component={InputTexto}
          gridColumn={gridColumn.gc6}
        />
        <InputFormik
          titulo="Empresa"
          id="Empresa"
          name="Empresa"
          component={InputAutoComplete}
          gridColumn={gridColumn.gc6}
          path="Empresa"
          autocomplete={true}
          database={localStorage.getItem('database')}
        />
        <InputFormik
          titulo="Responsável"
          id="Responsavel"
          name="Responsavel"
          component={InputTexto}
          gridColumn={gridColumn.gc3}
        />
        <InputFormik
          titulo="Telefone"
          id="Telefone"
          name="Telefone"
          component={InputTexto}
          gridColumn={gridColumn.gc3}
        />
        <InputFormik
          titulo="E-mail"
          id="Email"
          name="Email"
          component={InputTexto}
          gridColumn={gridColumn.gc6}
        />
      </Card>
      <Card titulo="ENDEREÇO">
        <InputFormik
          titulo="CEP"
          id="CEP"
          name="CEP"
          component={InputTexto}
          gridColumn={gridColumn.gc3}
        />
        <InputFormik
          titulo="Rua"
          id="RuaEndereco"
          name="RuaEndereco"
          component={InputTexto}
          gridColumn={gridColumn.gc4}
        />
        <InputFormik
          titulo="Número"
          id="NumeroEndereco"
          name="NumeroEndereco"
          component={InputTexto}
          gridColumn={gridColumn.gc2}
        />
        <InputFormik
          titulo="Complemento"
          id="ComplementoEndereco"
          name="ComplementoEndereco"
          component={InputTexto}
          gridColumn={gridColumn.gc3}
        />
        <InputFormik
          titulo="Bairro"
          id="BairroEndereco"
          name="BairroEndereco"
          component={InputTexto}
          gridColumn={gridColumn.gc4}
        />
        <InputFormik
          titulo="Cidade"
          id="CidadeEndereco"
          name="CidadeEndereco"
          component={InputTexto}
          gridColumn={gridColumn.gc6}
        />
        <InputFormik
          titulo="Estado"
          id="UFEndereco"
          name="UFEndereco"
          component={InputSelect}
          gridColumn={gridColumn.gc2}
          options={estados}
        />
      </Card>
    </>
  );
}

export default EditarEstoques;
